import { useState } from 'react';
import logoImage from '../assets/solra-icon-2048.png';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export default function Logo({ className = '', size = 'md' }: LogoProps) {
  const [showFallback, setShowFallback] = useState(false);

  const handleImageError = () => {
    setShowFallback(true);
  };

  if (showFallback) {
    return (
      <div className={`${sizeClasses[size]} flex items-center justify-center font-bold text-blue-600 ${className}`}>
        Solra
      </div>
    );
  }

  return (
    <img
      src={logoImage}
      alt="Solra logo"
      className={`${sizeClasses[size]} object-contain ${className}`}
      onError={handleImageError}
    />
  );
}
